<app-carousel
    [typeSearch]="'Employee'"
></app-carousel>
<div class="body-app my-4">
    <div class="content-app">
        <div class="row mb-5">
            <div class="col-12 mb-4">
                <h3 class="section-title">
                    <i class="fa-solid fa-briefcase me-2 text-primary"></i>
                    Ofertas laborales a las que apliqué
                </h3>
            </div>
            <div class="col-12">
                <app-job-offer-list [appliedOffers]="true"/>
            </div>
        </div>
        
        <div class="row mb-4">
            <div class="col-12 mb-4">
                <h3 class="section-title">
                    <i class="fa-solid fa-briefcase me-2 text-primary"></i>
                    Ofertas laborales que te pueden interesar
                </h3>
            </div>
            <div class="col-12">
                <app-job-offer-list [appliedOffers]="false"/>
            </div>
        </div>
    </div>
</div>